class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CdxCartSubscription extends HTMLElement {
  connectedCallback() {
    this._itemKey = this.dataset.itemKey;
    this._radios = this.querySelectorAll('[data-bsub-selling-plan-group-input]');
    this._select = this.querySelector('[data-bsub-selling-plan-select]');

    console.log('[bsub] connectedCallback', this._itemKey, 'radios:', this._radios.length);

    this._radios.forEach(r => {
      const label = r.closest('.bsub-widget__group-label') || r.parentElement;
      label.addEventListener('click', () => {
        if (r.checked) return;
        setTimeout(() => this._onRadioChange(r), 0);
      }, { capture: true });
    });
    if (this._select) this._select.addEventListener('change', () => this._onSelectChange());
  }

  _onRadioChange(radio) {
    const isOneTime = radio.hasAttribute('data-bsub-purchase-option-one-time');
    console.log('[bsub] radio change — isOneTime:', isOneTime, 'value:', radio.value);
    const planId = isOneTime ? null : this._getSelectedPlanId();
    this._update(planId);
  }

  _onSelectChange() {
    const checked = this.querySelector('[data-bsub-selling-plan-group-input]:checked');
    if (!checked || checked.hasAttribute('data-bsub-purchase-option-one-time')) return;
    const planId = parseInt(this._select.value) || null;
    if (planId) this._update(planId);
  }

  _getSelectedPlanId() {
    if (!this._select) return null;
    const val = parseInt(this._select.value);
    if (val) return val;
    const first = Array.from(this._select.options).find(o => o.value && o.value !== '');
    return first ? parseInt(first.value) : null;
  }

  async _update(sellingPlanId) {
    console.log('[bsub] _update — itemKey:', this._itemKey, 'sellingPlanId:', sellingPlanId);
    const body = {
      id: this._itemKey,
      selling_plan: sellingPlanId !== null ? sellingPlanId : 0
    };

    const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      console.error('[bsub] cart/change.js failed', res.status, await res.text());
      return;
    }

    const data = await res.json();
    if (data.errors) {
      console.error('[bsub] cart/change.js error', data.errors);
      return;
    }

    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems) cartDrawerItems.onCartUpdate();
  }
}

if (!customElements.get('cdx-cart-subscription')) {
  customElements.define('cdx-cart-subscription', CdxCartSubscription);
}
